// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3YENe","row":"styles_row__2vYPH"};